import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	errorTitleCmdbAssets: {
		id: 'issue-field-cmdb-object.error-title-cmdb-assets',
		defaultMessage: "We couldn't update the Assets objects field",
		description: 'Error title informing that updating the CMDB objects field has failed.',
	},
	errorMessage: {
		id: 'issue-field-cmdb-object.error-message',
		defaultMessage: 'Refresh the page and try again.',
		description: 'Error message when updating CMDB objects in a field has failed.',
	},
});
